import { CustomPageUser, CustomSettings } from 'interfaces/custompage'

export type CustomPagePayload = {
  id?: number
  backgroundColor?: string
  buttonColor?: string
  logo?: Blob
  backgroundImage?: Blob
}

export function updateInterface(payload: CustomPagePayload) {
  const { id, buttonColor, backgroundColor, backgroundImage, logo } = payload

  const data = new FormData()
  data.append('buttonColor', buttonColor)
  data.append('backgroundColor', backgroundColor)
  backgroundImage && data.append('backgroundImage', backgroundImage)
  logo && data.append('logo', logo)

  return {
    url: `/api/custom_pages/${id}/interface`,
    method: 'POST',
    headers: {
      Accept: 'application/ld+json',
      Authorization: null,
    },
    body: data,
  }
}

export function getCustomPage(customPageID: number) {
  return {
    url: `/api/custom_pages/${customPageID}`,
    method: 'GET',
    headers: {
      Accept: 'application/ld+json',
      'Content-Type': 'application/merge-patch+json',
      Authorization: null,
    },
  }
}

export function addUserClient(user: CustomPageUser) {
  return {
    url: `/api/custom_page_users`,
    method: 'POST',
    headers: {
      Accept: 'application/ld+json',
      'Content-Type': 'application/ld+json',
      Authorization: null,
    },
    body: JSON.stringify(user),
  }
}

export function getUserById(userId: number) {
  return {
    url: `/api/custom_page_users/${userId}`,
    method: 'GET',
    headers: {
      Accept: 'application/ld+json',
      'Content-Type': 'application/ld+json',
      Authorization: null,
    },
  }
}

export function updateUserClient(user: CustomPageUser, userId: number) {
  return {
    url: `/api/custom_page_users/${userId}`,
    method: 'PATCH',
    headers: {
      Accept: 'application/ld+json',
      'Content-Type': 'application/merge-patch+json',
      Authorization: null,
    },
    body: JSON.stringify(user),
  }
}

export function updateCustomSettings(customizeSettings: CustomSettings) {
  return {
    url: `/api/custom_page_advanced_settings`,
    method: 'POST',
    headers: {
      Accept: 'application/ld+json',
      'Content-Type': 'application/ld+json',
      Authorization: null,
    },
    body: JSON.stringify(customizeSettings),
  }
}
